import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { RosterEmploymentScreen } from '@/features/hr-reports/roster-employment-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/roster-employment')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RosterEmploymentScreenRoute,
})

function RosterEmploymentScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <RosterEmploymentScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/hr/reports/roster-employment', search: next })
      }
    />
  )
}
